module.exports = __webpack_public_path__ + "static/media/wspfoto.da4ca989.png";